<template>
    <div class="admin_main_wrapper">
        <SecondLevelDetailsConfig :admin="true"></SecondLevelDetailsConfig>
    </div>
</template>

<script>
    import SecondLevelDetailsConfig from "../../widgets/SecondLevelDetailsConfig";

    export default {
        name: "SecondLevelDetails",
        components: {
            SecondLevelDetailsConfig,
        },
        data() {
            return {}
        },

    }

</script>

<style scoped>

</style>